import { Marker, useGoogleMap } from '@react-google-maps/api';
import React, { useEffect } from 'react';
import { Control, useWatch } from 'react-hook-form';
import { FormData } from './UpsertBoxForm';

interface Props {
  control: Control<FormData>;
}

const panToMarker = (map: google.maps.Map, position: google.maps.LatLng) => {
  if (map.getZoom() < 18) map.setZoom(18);
  setTimeout(() => {
    map.panTo(position);
  }, 10);
};

const AdminBoxMarker = ({ control }: Props) => {
  const map = useGoogleMap();

  const coords = useWatch<FormData>({ control, name: ['lat', 'lng'] });

  const position =
    coords.lat && coords.lng
      ? new google.maps.LatLng(coords.lat, coords.lng)
      : null;

  useEffect(() => {
    if (map && position) {
      panToMarker(map, position);
    }
  }, [map, position]);

  const onDragEnd = (e: google.maps.MouseEvent) => {
    control.setValue('lat', e.latLng.lat());
    control.setValue('lng', e.latLng.lng());
  };

  return position && map ? (
    <Marker position={position} draggable onDragEnd={onDragEnd} />
  ) : null;
};

export default AdminBoxMarker;
